import { Component, Input, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-game-header-small',
    templateUrl: './game-header-small.component.html',
    styleUrls: ['./game-header-small.component.css'],
    imports: [MatIcon, DatePipe]
})
export class GameHeaderSmallComponent implements OnInit {

  @Input() Game;
  constructor() { }

  ngOnInit() {
  }

}
